export default __webpack_public_path__ + "static/imgWeddingpng-0202fb27e17280bcc96291bcbc1eb0fa.png";